import { useEffect, useLayoutEffect } from 'react';

// eslint-disable-next-line jira/jira-ssr/no-server-variable
const useLayoutEffectSafe: typeof useEffect = __SERVER__ ? useEffect : useLayoutEffect;

export default useLayoutEffectSafe;
